import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

type Props = { roles: string[] }

export const RoleProtectedRoute = ({ roles }: Props) => {
  const { isAuthenticated, user } = useAuth()
  const loc = useLocation()
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: loc }} replace />
  const userRoles = user?.roles || []
  const ok = roles.some(r => userRoles.includes(r) || userRoles.includes(r.replace('ROLE_','')))
  if (!ok) return <Navigate to="/forbidden" replace />
  return <Outlet />
}

export default RoleProtectedRoute
